import { render, staticRenderFns } from "./AuthForgotNotify.vue?vue&type=template&id=bc77e2ec&"
import script from "./AuthForgotNotify.vue?vue&type=script&lang=js&"
export * from "./AuthForgotNotify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc77e2ec')) {
      api.createRecord('bc77e2ec', component.options)
    } else {
      api.reload('bc77e2ec', component.options)
    }
    module.hot.accept("./AuthForgotNotify.vue?vue&type=template&id=bc77e2ec&", function () {
      api.rerender('bc77e2ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/auth/screens/AuthForgotNotify.vue"
export default component.exports